






import Home from './components/pages/Home.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'App',

  components: {
    Home
  },

  created() {
    this.$i18n.locale = navigator.language?.substring(0, 2)
  }
})
